module.exports = __webpack_public_path__ + "img/icon-search-white.c169e6b7.svg";